;(() => {
  function svgIcon(name, className) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    svg.setAttribute("class", className)
    const use = document.createElementNS("http://www.w3.org/2000/svg", "use")
    use.setAttributeNS("http://www.w3.org/1999/xlink", "href", `#i--${name}`)
    svg.appendChild(use)
    return svg
  }

  window.HB = window.HB || {}
  window.HB.svgIcon = svgIcon
})()
